import React from "react";
import { Info } from "lucide-react";
import Tooltip from "../common/Tooltip";

// One consistent "i" info affordance for non-obvious fields across the
// Club-Network flows (DoD 24). Wraps the shared platform Tooltip. The shared
// Tooltip hard-codes `whitespace-nowrap` on its bubble, which would keep long
// help text on one line and overflow the dark background — so we force wrapping
// with `!whitespace-normal` (Tailwind important beats the base regardless of
// class order) and cap the width so the bubble hugs its text and grows in
// height instead of clipping.
const InfoTip = ({ text, position = "top", className = "" }) => (
  <Tooltip
    content={text}
    position={position}
    className={`!whitespace-normal max-w-[240px] text-[12px] font-normal leading-snug ${className}`}
  >
    <Info className="w-3.5 h-3.5 text-gray-400 hover:text-gray-600" aria-hidden="true" />
  </Tooltip>
);

export default InfoTip;
